import { LinkProps } from 'shared/link/Link.types';
import { Link } from 'store/api/cms/types/response.types';

export const adaptApiLink: (link: Link) => LinkProps = link => ({
  external: !!link.externalUrl,
  label: link.label,
  subLinks: link.subLinks ? link.subLinks.map(l => adaptApiLink(l)) : [],
  url: link.externalUrl || link.internalUrl,
});
